import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

interface TreeNode {
  id: number;
  name: string;
  Atividade: string;
  EDT: string;
  description: string;
  status: string;
  employees: string;
  budget: string;
  inicio: string;
  fim: string;
  children?: TreeNode[];
  expanded?: boolean; // Controle para expandir/colapsar
}

interface CronogramaEmpresa {
  id: number;
  nome: string;
  dataCriacao: string;
}

@Component({
  selector: 'app-cronograma-a-fazer',
  templateUrl: './cronograma-a-fazer.component.html',
  styleUrls: ['./cronograma-a-fazer.component.scss']
})
export class CronogramaAFazerComponent implements OnInit {


  dataSource = [];
  cronogramas: CronogramaEmpresa[] = [];
  cronogramaSelecionado: number | null = null;
  idEmpresa: number;

  constructor(
    private ajax: AjaxService,
    private util: UtilService,
    private route: ActivatedRoute,
    private userService: UserService
  ) {

  }

  ngOnInit(): void {
     let user = this.userService.getUserData();
     console.log(user.User.Id);
      this.idEmpresa = 2;
      if (this.idEmpresa) {
        this.carregarCronogramasEmpresa();
      }
  
  }
  carregarCronogramasEmpresa() {
    this.util.showLoading();
    this.ajax.get(`${API}CronogramaEmpresa/CronogramaEmpresa?ID_EMPRESA=${this.idEmpresa}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.cronogramas = response.data;
            if (this.cronogramas.length > 0) {
              this.cronogramaSelecionado = this.cronogramas[0].id;
              this.carregarCronogramaVisaoGeral();
            }
          } else {
            this.cronogramas = [];
            console.log('Nenhum cronograma encontrado');
          }
        },
        error: (error) => {
          this.util.closeLoading();
          console.error('Erro ao carregar cronogramas:', error);
        }
      });
  }

  carregarCronogramaVisaoGeral() {
    if (!this.cronogramaSelecionado) return;

    this.util.showLoading();
    this.ajax.get(`${API}CronogramaEmpresa/CronogramaEmpresa/buscarCronogramaVisaoGeral?ID_CRONOGRAMA_EMPRESA=${this.cronogramaSelecionado}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.dataSource = response.data[0].children;
          } else {
            this.dataSource = [];
            console.log('Nenhum dado encontrado para o cronograma selecionado');
          }
        },
        error: (error) => {
          this.util.closeLoading();
          console.error('Erro ao carregar cronograma:', error);
        }
      });
  }

  onCronogramaChange() {
    this.carregarCronogramaVisaoGeral();
  }

  // Alterna a expansão do nó
  toggleExpand(node: TreeNode) {
    node.expanded = !node.expanded;
  }

 
} 